import { z } from 'zod'
import { publicKolInfoSchema } from '@/types/schema/kol/public-kol-info-schema'

export interface FetchKolInfoRequest {
  radar_uuid: string
  dc_id_hashed?: string
}

export const kolInfoSchema = publicKolInfoSchema
  .extend({
    is_radar_star: z.boolean(),
    snapshot_at: z.string().datetime().nullable(),
    snapshot_updated_at: z.string().datetime().nullable(),
    with_new_data_to_unlock: z.boolean().nullable(),
    is_added_to_directory: z.boolean(),
    is_expired: z.boolean(),
    dc_id_hashed: z.string().optional(),
  })
  .transform((val) => {
    const [name, ...subName] = val.name.split('|')

    return {
      ...val,
      name,
      sub_name: subName,
    }
  })

export type KolInfo = z.infer<typeof kolInfoSchema>
